import React from 'react'
import { UpgradeTideways6 } from './UpgradeTideways6'

interface Props {
    upgrade: UpgradeTideways6
    projectId: string
    projectSize: number
    plan: string
    onlyAfter: boolean
}

class BeforeAfterProjectLimitsSection extends React.Component<Props> {
    public render() {
        const application = this.props.upgrade.applications.find(app => app.id === parseInt(this.props.projectId, 10))

        if (!application) {
            return null
        }

        const limitedTransactionsBatchSize = this.getLimitedTransactionBatchSize(this.props.plan)
        const fullTransactionsBatchSize = this.getTransactionBatchSize(this.props.plan)
        const limitedModifier = this.props.plan.indexOf('tideways7') >= 0 ? 1 : this.props.projectSize

        const newServiceLimit = this.props.projectSize
        const newEnvironmentLimit = this.props.plan.indexOf('tideways7') >= 0 ? 1 + this.props.projectSize : this.props.projectSize * 2
        const newLimitedVisibilityTransactions = limitedModifier * limitedTransactionsBatchSize
        const newFullVisibilityTransactions = this.props.projectSize * fullTransactionsBatchSize
        const newTracesPerMinute = this.getTracesPerMinute(this.props.plan, this.props.projectSize)

        const style = this.props.onlyAfter ? { backgroundColor: '#f4f4f4' } : {}

        return (
            <table className={'table ' + (this.props.onlyAfter ? '' : 'table-striped')} style={style}>
                <tbody>
                    {this.props.onlyAfter ? (
                        ''
                    ) : (
                        <tr>
                            <th></th>
                            <th>Limits Currently</th>
                            <th>After Upgrade</th>
                        </tr>
                    )}
                    <tr>
                        <td>Services:</td>
                        {this.props.onlyAfter ? (
                            ''
                        ) : (
                            <td>
                                {this.props.upgrade.currentBillingMetrics[application.id].services}/{application.activeServices}
                            </td>
                        )}
                        <td>
                            {this.props.upgrade.currentBillingMetrics[application.id].services}/{newServiceLimit}
                        </td>
                    </tr>
                    <tr>
                        <td>Environments:</td>
                        {this.props.onlyAfter ? (
                            ''
                        ) : (
                            <td>
                                {this.props.upgrade.currentBillingMetrics[application.id].environments}/{application.activeEnvironments}
                            </td>
                        )}
                        <td>
                            {this.props.upgrade.currentBillingMetrics[application.id].environments}/{newEnvironmentLimit}
                        </td>
                    </tr>
                    <tr>
                        <td>Traces/Minute:</td>
                        {this.props.onlyAfter ? '' : <td>{this.props.upgrade.availableFeatures[application.id].defaultTracesPerMinute}</td>}
                        <td>{newTracesPerMinute}</td>
                    </tr>
                    <tr>
                        <td>Transactions with Full Visibility:</td>
                        {this.props.onlyAfter ? (
                            ''
                        ) : (
                            <td>
                                {this.props.upgrade.currentBillingMetrics[application.id].transactions.fullVisibility}/
                                {this.props.upgrade.availableFeatures[application.id].transactionLimits.fullVisibility}
                            </td>
                        )}
                        <td>
                            {this.props.upgrade.currentBillingMetrics[application.id].transactions.fullVisibility}/
                            {newFullVisibilityTransactions}
                        </td>
                    </tr>
                    <tr>
                        <td>Transactions With Limited Visiblity:</td>
                        {this.props.onlyAfter ? (
                            ''
                        ) : (
                            <td>
                                {this.props.upgrade.currentBillingMetrics[application.id].transactions.limitedVisibility}/
                                {this.props.upgrade.availableFeatures[application.id].transactionLimits.limitedVisibility}
                            </td>
                        )}
                        <td>
                            {this.props.upgrade.currentBillingMetrics[application.id].transactions.limitedVisibility}/
                            {newLimitedVisibilityTransactions}
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    private getTransactionBatchSize(plan: string) {
        switch (plan) {
            case 'tideways6_pro':
            case 'tideways7_pro':
                return 500
            case 'tideways6_standard':
                return 250
            case 'tideways6_basic':
                return 125
            case 'tideways6_starter':
                return 20
            case 'tideways7_standard':
                return 200
            case 'tideways7_basic':
                return 50
        }
        return 100
    }

    private getLimitedTransactionBatchSize(plan: string) {
        if (plan === 'tideways6_starter') {
            return 480
        }

        if (plan === 'tideways7_basic') {
            return 1000
        }

        if (plan === 'tideways7_standard') {
            return 2000
        }

        if (plan === 'tideways7_pro') {
            return 5000
        }

        return this.getTransactionBatchSize(plan) * this.getLimitedTransactionMultiplier(plan)
    }

    /** See AvailableFeatures::getTransactionLimits for equivalent PHP code */
    private getLimitedTransactionMultiplier(plan: string) {
        switch (plan) {
            case 'tideways6_pro':
                return 2
            case 'tideways6_standard':
                return 2
            case 'tideways6_basic':
                return 3
        }
        return 2
    }

    private getTracesPerMinute(plan: string, projectSize: number) {
        // implement based on PHP AvailableFeatures::getDefaultTracesPerMinute
        if (plan === 'tideways6_pro') {
            return projectSize * 25
        } else if (plan === 'tideways6_standard') {
            return projectSize * 10
        } else if (plan === 'tideways6_basic') {
            return projectSize * 5
        } else if (plan === 'tideways6_starter') {
            return projectSize * 5
        } else if (plan === 'tideways7_standard') {
            return 20 + (projectSize - 1) * 10
        } else if (plan === 'tideways7_basic') {
            return 10 + (projectSize - 1) * 5
        } else if (plan === 'tideways7_pro') {
            return 50 + (projectSize - 1) * 25
        }
        return 1
    }
}

export default BeforeAfterProjectLimitsSection
